import { PostShoppingCartCheckout, ShoppingCart } from '@ravago/shared/page-data/models/features';

export class ShoppingCartUtils {
  static async getShoppingCart(): Promise<ShoppingCart> {
    const response = await fetch(`/api/customers/shopping-cart`);
    const emptyCart: ShoppingCart = {
      items: [],
      numberOfItems: 0,
      problems: [],
      deliveryAddressId: undefined
    };
    if (response.ok) {
      return response.json();
    }
    return emptyCart;
  }

  static async checkout(request: PostShoppingCartCheckout): Promise<string> {
    const response = await fetch(`/api/customers/checkout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    });
    if (response.ok) {
      return response.json();
    }
    return '';
  }
}
